<ion-progress-bar color="primary" [value]="progress / 100">
</ion-progress-bar>
<div class="progressbar-container-value">
  <span [style.left]="progress + '%'">
    {{ progress / 100 | percent }}
  </span>
</div>
